import { supabase } from '@/lib/supabase';
import { getTodayBRT } from '@/utils';

const cleanOldDailyLogins = (currentKey: string) => {
    try {
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('daily_login_') && key !== currentKey) {
                localStorage.removeItem(key);
            }
        });
    } catch (e) {
        console.warn('Failed to clean old daily logins:', e);
    }
};

export const registerDailyLogin = async (userId: string) => {
    const today = getTodayBRT();
    const storageKey = `daily_login_${userId}_${today}`;

    // Clean up old entries to keep localStorage tidy
    cleanOldDailyLogins(storageKey);

    // Optimization: Check localStorage first to avoid unnecessary API calls
    if (localStorage.getItem(storageKey)) {
        return;
    }

    try {
        const { data: { session } } = await supabase.auth.getSession();

        if (!session?.access_token) {
            console.error('No active session for daily login check');
            return;
        }

        const response = await fetch('/.netlify/functions/loyalty-action', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session.access_token}`
            },
            body: JSON.stringify({ action: 'daily_login' })
        });

        if (response.ok) {
            // Success or already registered (handled by backend 200 OK)
            localStorage.setItem(storageKey, 'true');
        } else {
            console.error('Failed to register daily login:', await response.text());
        }
    } catch (err) {
        console.error('Unexpected error in daily login service:', err);
    }
};

export const registerCompleteSignup = async () => {
    try {
        const { data: { session } } = await supabase.auth.getSession();

        if (!session?.access_token) return;

        await fetch('/.netlify/functions/loyalty-action', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${session.access_token}`
            },
            body: JSON.stringify({ action: 'complete_signup' })
        });

    } catch (err) {
        console.error('Error in complete signup loyalty:', err);
    }
};

export const shouldShowBirthdayModal = (birthdate: string, userId: string) => {
    const parts = birthdate.split('-');
    if (parts.length >= 2) {
        const bMonth = parseInt(parts[1], 10);
        const currentMonth = new Date().getMonth() + 1;

        if (bMonth === currentMonth) {
            const year = new Date().getFullYear();
            const claimedKey = `birthday_claimed_${userId}_${year}`;

            return !localStorage.getItem(claimedKey);
        }

        return false;
    }
};